import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router";
import { Tabs } from "../../../components";
import { Container, HeadWrapper, InstanceName, NavWrapper } from "./styles";
import AdvancedSettings from "./components/AdvancedSettings";
import Currencies from "./components/Currencies";

const SettingsGeneral: FC = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>("currencies");

  const tabs = [
    {
      title: t("CURRENCIES"),
      slug: "currencies",
      id: "2",
    },
    {
      title: t("ADVANCED_SETTINGS"),
      slug: "advanced-settings",
      id: "1",
    },
  ];

  useEffect(() => {
    const lastSegment = location.pathname.split("/").pop();
    const found = tabs.find((item) => item.slug === lastSegment);
    if (found) {
      setActiveTab(found.slug);
    }
  }, [location.pathname]);

  return (
    <Container>
      <HeadWrapper>
        <InstanceName>{t("GENERAL_SETTINGS")}</InstanceName>
      </HeadWrapper>
      <NavWrapper>
        <div>
          <Tabs
            tabs={tabs}
            size="display"
            blockNavigate
            location={activeTab}
            onChange={(slug) => {
              navigate(`/settings/general/${slug}`);
            }}
          />
        </div>
      </NavWrapper>

      <Routes>
        <Route path="/" element={<Navigate replace to="currencies" />} />
        <Route path="/advanced-settings" element={<AdvancedSettings />} />
        <Route path="/currencies" element={<Currencies />} />
      </Routes>
    </Container>
  );
};

export default SettingsGeneral;
